import axios from '../../../build/http-requests/axios-common'
import _ from 'underscore'
import store from '../index'
import Vue from 'vue'

const removeAllotment = ({ commit }, allotmentIdsToHandle) => {
  return new Promise((resolve, reject) => {
    commit('REMOVE_ALLOTMENT', allotmentIdsToHandle)
    resolve()
  })
}

const setBankStat = ({ commit }, row) => {
  return new Promise((resolve, reject) => {
    commit('SET_BANK_STAT', row)
    resolve()
  })
}

const setFinMov = ({ commit }, row) => {
  return new Promise((resolve, reject) => {
    commit('SET_FIN_MOV', row)
    resolve()
  })
}

const setBankStatArray = ({ commit }, array) => {
  return new Promise((resolve, reject) => {
    commit('SET_BANK_STAT_ARRAY', array)
    resolve()
  })
}

const setFinMovArray = ({ commit }, array) => {
  return new Promise((resolve, reject) => {
    commit('SET_FIN_MOV_ARRAY', array)
    resolve()
  })
}

const alertConfirmation = () => {
  let $t = Vue.i18n.translate
  let size = store.getters.arrayJustify ? store.getters.arrayJustify.length : 0
  if (size > 0) {
    let confirmation = null
    if (size > 1) {
      confirmation = window.confirm($t('conciliacaoManual.labels.alertJustificativas'))
    } else {
      confirmation = window.confirm($t('conciliacaoManual.labels.alertJustificativa'))
    }
    return confirmation
  } else {
    return true
  }
}

export default {
  state: {
    finMovAdded: [],
    idRowMovFinRemoved: {},
    bankStatAdded: [],
    idRowBankStatRemoved: {},
    totalAmountForInternalEntries: 0.00,
    totalAmountForBankEntries: 0.00,
    idRowAllotmentMovementRemoved: null,
    idRowAllotmentMovementAdded: null,
    idAllotment: null,
    hasPendingFinMov: false,
    hasPendingBankStat: false,
    hasToUpdateMAnualConcilSearch: false,
    arrayConciliationPlan: [],
    needSearchManualConciliationTransactions: false,
    allotmentMovementRemoved: null,
    arrayJustify: [],
    reaplyConciliation: false,
    loadingMessage: 'conciliacaoManual.labels.salvandoInformacoes'
  },

  mutations: {
    SET_ARRAY_CONCILIATION_PLAN (state, data) {
      state.arrayConciliationPlan = []
      state.arrayConciliationPlan.push(data)
    },
    SET_NEED_SEARCH_MANUAL_CONCILIATION (state, flag) {
      state.hasToUpdateMAnualConcilSearch = flag
    },
    HAS_PENDING_FIN_MOV (state, flag) {
      state.hasPendingFinMov = flag
    },
    HAS_PENDING_BANK_STAT (state, flag) {
      state.hasPendingBankStat = flag
    },
    HAS_TO_UPDATE_MANUAL_CONCIL_SEARCH (state, flag) {
      state.hasToUpdateMAnualConcilSearch = flag
    },
    SET_FIN_MOV (state, row) {
      let data = {}
      if (row.isTreeGrid) {
        data = {
          'id': row.id,
          'idMovimentacao': row.IdMovimentacao,
          'dtLanc': row.DtLanc,
          'valor': row.VlLancamento,
          'situacao': row.SituacaoConciliacao
        }
      } else {
        data = row
      }
      state.finMovAdded.push(data)
    },
    SET_FIN_MOV_ARRAY (state, finMovArray) {
      state.finMovAdded = state.finMovAdded.concat(finMovArray)
    },
    REMOVE_FIN_MOV (state, row) {
      state.finMovAdded = _.without(state.finMovAdded, _.findWhere(state.finMovAdded, { id: row.id }))
      if (row && row.id) {
        state.idRowMovFinRemoved = {
          id: row.id,
          idMovimentacao: row.idMovimentacao
        }
      }
      state.allotmentMovementRemoved = row && row.idLote ? row.idLote : state.allotmentMovementRemoved
    },
    SET_BANK_STAT (state, row) {
      let data = {}
      if (row.isTreeGrid) {
        data = {
          'id': row.id,
          'idLancamento': row.IdLancamento,
          'idMovBank': row.IdMovimentoBancario,
          'dtLanc': row.DtLanc,
          'valor': row.VlLancamento,
          'situacao': row.SituacaoConciliacao,
          'isTreeGrid': true
        }
      } else {
        data = row
      }
      state.bankStatAdded.push(data)
    },
    SET_BANK_STAT_ARRAY (state, bankStatArray) {
      state.bankStatAdded = state.bankStatAdded.concat(bankStatArray)
    },
    REMOVE_BANK_STAT (state, row) {
      state.bankStatAdded = _.without(state.bankStatAdded, _.findWhere(state.bankStatAdded, { id: row.id }))
      if (row && row.id) {
        state.idRowBankStatRemoved = {
          id: row.id,
          idLancamento: row.idLancamento
        }
      }
      state.allotmentMovementRemoved = row && row.idLote ? row.idLote : state.allotmentMovementRemoved
    },
    REMOVE_ALL_BANK (state, list) {
      list.forEach(row => {
        state.bankStatAdded = _.without(state.bankStatAdded, _.findWhere(state.bankStatAdded, { id: row.id }))
        if (window.Grids.ConcManualExtBan) {
          let item = window.Grids.ConcManualExtBan.GetRowById(row.id)
          if (!item) {
            item = _.findWhere(window.Grids.ConcManualExtBan.Rows, { IdLancamento: row.idLancamento })
          }
          if (item) {
            window.Grids.ConcManualExtBan.ShowRow(item)
          }
          window.Grids.ConcManualExtBan.Reload()
        }
      })
    },
    REMOVE_ALL_MOV (state, list) {
      list.forEach(row => {
        state.finMovAdded = _.without(state.finMovAdded, _.findWhere(state.finMovAdded, { id: row.id }))
        if (window.Grids.ConcManualMovFin) {
          let item = window.Grids.ConcManualMovFin.GetRowById(row.id)
          if (!item) {
            item = _.findWhere(window.Grids.ConcManualMovFin.Rows, { IdMovimentacao: row.idMovimentacao })
          }
          if (item) {
            window.Grids.ConcManualMovFin.ShowRow(item)
          }
          window.Grids.ConcManualMovFin.Reload()
        }
      })
    },
    UPDATE_TOTAL_AMOUNT_INTERNAL (state, value) {
      state.totalAmountForInternalEntries = value
    },
    UPDATE_TOTAL_AMOUNT_BANK (state, value) {
      state.totalAmountForBankEntries = value
    },
    REMOVE_ALLOTMENT (state, allotmentIdsToHandle) {
      let idLote = {}
      if (state.bankStatAdded && state.bankStatAdded.length > 0) {
        state.bankStatAdded.forEach(obj => {
          if (obj.idLote) {
            if (!idLote) {
              idLote = obj.idLote
            }
            state.bankStatAdded = _.without(state.bankStatAdded, _.findWhere(state.bankStatAdded, { idLote: obj.idLote }))
          }
        })
      }

      if (state.finMovAdded && state.finMovAdded.length > 0) {
        state.finMovAdded.forEach(obj => {
          if (obj.idLote) {
            if (!idLote) {
              idLote = obj.idLote
            }
            state.finMovAdded = _.without(state.finMovAdded, _.findWhere(state.finMovAdded, { idLote: obj.idLote }))
          }
        })
      }
      state.idRowAllotmentMovementRemoved = allotmentIdsToHandle.idAllotmentRemoved
      state.idRowAllotmentMovementAdded = allotmentIdsToHandle.idAllotmentToRemove
      state.allotmentMovementRemoved = null
    },
    SET_ID_ALLOTMENT (state, id) {
      state.idAllotment = id
      state.allotmentMovementRemoved = null
    },
    SET_JUSTIFY (state, justify) {
      state.arrayJustify.push(justify)
    },
    REMOVE_JUSTIFY (state, row) {
      state.arrayJustify = _.without(state.arrayJustify, _.findWhere(state.arrayJustify, { id: row.id }))
    },
    CLEAN_ARRAY_JUSTIFY (state) {
      state.arrayJustify = []
    },
    SET_REAPLY_CONCILIATION (state, value) {
      state.reaplyConciliation = value
    },
    SET_LOADING_MESSAGE (state, value) {
      state.loadingMessage = value
    },
    CLEAN_EDIT_STATE (state) {
      state.planToEditId = null
      state.profileToEditId = null
      state.bankAccounttoEditId = null
      state.establishmentToEditId = null
      state.lastUrl = null
      state.occurrenceReasonToEditId = null
      state.finMovAdded = []
      state.idRowMovFinRemoved = {}
      state.bankStatAdded = []
      state.idRowBankStatRemoved = {}
      state.idRowAllotmentMovementRemoved = null
      state.idRowAllotmentMovementAdded = null
      state.totalAmountForInternalEntries = 0.00
      state.totalAmountForBankEntries = 0.00
      state.idAllotment = null
      state.hasPendingFinMov = false
      state.hasPendingBankStat = false
      state.hasToUpdateMAnualConcilSearch = false
      state.arrayConciliationPlan = []
      state.allotmentMovementRemoved = null
      state.arrayJustify = []
      state.loadingMessage = 'conciliacaoManual.labels.salvandoInformacoes'
    }
  },

  actions: {
    applyConciliation: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/manualConciliation/applyConciliation', filter)
          .then(response => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
      })
    },

    reopenConciliation: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/manualConciliation/reopenConciliation', filter)
          .then(response => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
      })
    },

    justifyConciliation: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/manualConciliation/justifyConciliation', filter).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    searchTransactionsForManualConciliation: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/manualConciliation/searchTransactionsForManualConciliation', filter)
          .then(response => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
      })
    },

    searchAllotments: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/manualConciliation/searchAllotments', filter)
          .then(allotments => {
            resolve(allotments.data)
          }).catch((error) => {
            reject(error)
          })
      })
    },

    reaplyConciliation: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/manualConciliation/reaplyConciliation', filter)
          .then(response => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
      })
    },

    verifyReaplyConciliation: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/manualConciliation/verifyReaplyConciliation')
        .then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    removeFinMov: ({ commit }, row) => {
      return new Promise((resolve, reject) => {
        commit('REMOVE_FIN_MOV', row)
        resolve()
      })
    },

    removeBankStat: ({ commit }, row) => {
      return new Promise((resolve, reject) => {
        commit('REMOVE_BANK_STAT', row)
        resolve()
      })
    },

    removeAllBankStat: ({ commit }, list) => {
      return new Promise((resolve, reject) => {
        commit('REMOVE_ALL_BANK', list)
        resolve()
      })
    },

    removeAllMovFin: ({ commit }, list) => {
      return new Promise((resolve, reject) => {
        commit('REMOVE_ALL_MOV', list)
        resolve()
      })
    },

    recoverAllotmentMov: ({ commit }, idLote) => {
      return new Promise((resolve, reject) => {
        axios.get('/manualConciliation/listAllotmentMov', { params: { allotmentId: idLote } })
          .then(allotments => {
            resolve(allotments.data)
          }).catch((error) => {
            reject(error)
          })
      })
    },

    getAllotmentMov: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.get('/manualConciliation/listAllotmentMov', { params: { allotmentId: data.row.IdLote } })
          .then(response => {
            let allotmentData = {
              'idAllotmentToRemove': data.row.id,
              'idAllotmentRemoved': data.idAllotmentRemoved
            }
            removeAllotment({ commit }, allotmentData)
            if (response.data.bankMovements && response.data.bankMovements.length > 0) {
              setBankStatArray({ commit }, response.data.bankMovements)
            }
            if (response.data.financialMovements && response.data.financialMovements.length > 0) {
              setFinMovArray({ commit }, response.data.financialMovements)
            }
            resolve()
          }).catch((error) => {
            reject(error)
          })
      })
    },

    setIdAllotment: ({ commit }, id) => {
      return new Promise((resolve, reject) => {
        commit('SET_ID_ALLOTMENT', id)
        resolve()
      })
    },

    updateTotalAmountForInternalEntries: ({ commit }, value) => {
      return new Promise((resolve, reject) => {
        commit('UPDATE_TOTAL_AMOUNT_INTERNAL', value)
        resolve()
      })
    },

    updateTotalAmountForBankEntries: ({ commit }, value) => {
      return new Promise((resolve, reject) => {
        commit('UPDATE_TOTAL_AMOUNT_BANK', value)
        resolve()
      })
    },

    hasPendingFinMov: ({ commit }, flag) => {
      return new Promise((resolve, reject) => {
        commit('HAS_PENDING_FIN_MOV', flag)
        resolve()
      })
    },

    hasPendingBankStat: ({ commit }, flag) => {
      return new Promise((resolve, reject) => {
        commit('HAS_PENDING_BANK_STAT', flag)
        resolve()
      })
    },

    hasToUpdateMAnualConcilSearch: ({ commit }, flag) => {
      return new Promise((resolve, reject) => {
        commit('HAS_TO_UPDATE_MANUAL_CONCIL_SEARCH', flag)
        resolve()
      })
    },

    setArrayConciliationPlan: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        commit('SET_ARRAY_CONCILIATION_PLAN', data)
        resolve()
      })
    },

    setNeedSearchManualConciliationTransactions: ({ commit }, flag) => {
      return new Promise((resolve, reject) => {
        commit('SET_NEED_SEARCH_MANUAL_CONCILIATION', flag)
        resolve()
      })
    },

    cleanEditState: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAN_EDIT_STATE')
        resolve()
      })
    },

    setJustify: ({ commit }, justify) => {
      return new Promise((resolve, reject) => {
        commit('SET_JUSTIFY', justify)
        resolve()
      })
    },

    removeJustify: ({ commit }, row) => {
      return new Promise((resolve, reject) => {
        commit('REMOVE_JUSTIFY', row)
        resolve()
      })
    },

    cleanArrayJustify: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAN_ARRAY_JUSTIFY')
        resolve()
      })
    },

    alertUser: ({ commit }) => {
      return new Promise((resolve, reject) => {
        let confirmation = alertConfirmation()
        if (confirmation) {
          resolve()
        } else {
          reject()
        }
      })
    },

    setReaplyConciliation: ({ commit }, flag) => {
      return new Promise((resolve) => {
        commit('SET_REAPLY_CONCILIATION', flag)
        resolve()
      })
    },

    setLoadingMessage: ({ commit }, msg) => {
      return new Promise((resolve) => {
        commit('SET_LOADING_MESSAGE', msg)
        resolve()
      })
    },

    setFinMov,
    setBankStat,
    setFinMovArray,
    setBankStatArray,
    removeAllotment,
    alertConfirmation
  },

  getters: {
    hasToUpdateMAnualConcilSearch: state => state.hasToUpdateMAnualConcilSearch,
    finMovAdded: state => state.finMovAdded,
    idRowMovFinRemoved: state => state.idRowMovFinRemoved,
    bankStatAdded: state => state.bankStatAdded,
    idRowBankStatRemoved: state => state.idRowBankStatRemoved,
    totalAmountForInternalEntries: state => state.totalAmountForInternalEntries,
    totalAmountForBankEntries: state => state.totalAmountForBankEntries,
    idRowAllotmentMovementRemoved: state => state.idRowAllotmentMovementRemoved,
    idRowAllotmentMovementAdded: state => state.idRowAllotmentMovementAdded,
    idAllotment: state => state.idAllotment,
    hasPendingFinMov: state => state.hasPendingFinMov,
    hasPendingBankStat: state => state.hasPendingBankStat,
    arrayConciliationPlan: state => state.arrayConciliationPlan,
    needSearchManualConciliationTransactions: state => state.needSearchManualConciliationTransactions,
    allotmentMovementRemoved: state => state.allotmentMovementRemoved,
    arrayJustify: state => state.arrayJustify,
    isReaplyConciliation: state => state.reaplyConciliation,
    loadingMessage: state => state.loadingMessage
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/manualConciliation.js